var React = require('react');

function FooterFacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0-fb{fill:#ADADAD;}\n"),React.createElement("path",{"className":"st0-fb","d":"M13.6,3.5c0.2-0.3,1-0.5,2.3-0.5c1.2,0,2.5,0,2.5,0c0.8,0,1.5-0.6,1.5-1.5c0-0.8-0.6-1.5-1.5-1.5\n\tc0,0-1.3,0-2.6,0c-1.4,0-3.4,0.3-4.5,1.5c-0.9,1-1.4,2.3-1.4,3.7c0,0.7,0,1.5,0,2.3H7.6C6.7,7.5,6,8.2,6,9c0,0.8,0.7,1.5,1.5,1.5\n\th2.4c0,6.5,0,13.9,0,14c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5c0-0.1,0-7.5,0-14h4.3c0.8,0,1.5-0.7,1.5-1.5c0-0.8-0.7-1.5-1.5-1.5\n\tH13c0-0.8,0-1.6,0-2.3C13,4.5,13.2,3.9,13.6,3.5z","key":1})]);
}

FooterFacebookIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 26 26","style":{"enableBackground":"new 0 0 26 26"},"xmlSpace":"preserve"};

module.exports = FooterFacebookIcon;

FooterFacebookIcon.default = FooterFacebookIcon;
